import omitBy from 'lodash/omitBy';
import useSWR from 'swr';

import { IPaginatedResponse } from 'utils/types';

import { fetcher } from './utils';

export interface IAppTrigger {
  id: number;
  name: string;
}

export const useAppTriggerList = (params?: Record<string, any>, shouldFetch = true) => {
  const sanitizedParams = params ? omitBy(params, value => value === undefined) : undefined;
  const key = shouldFetch
    ? { url: '/v4/dash/automation/app_triggers', params: sanitizedParams }
    : null;

  const { data, isLoading, error, mutate, isValidating } = useSWR<IPaginatedResponse<IAppTrigger>>(
    key,
    fetcher
  );

  return { data: data?.data, meta: data?.meta, isLoading, error, mutate, isValidating };
};

export const useAppTrigger = (id?: number | string | null, params?: Record<string, any>) => {
  const key = id ? { url: `/v4/dash/automation/app_triggers/${id}`, params } : null;
  const { data, isLoading, error, mutate, isValidating } = useSWR<IAppTrigger>(key, fetcher);

  return { data, isLoading, error, mutate, isValidating };
};
